const ProjectData = {
    "projects": [
        {
            "id": 1,
            "title": "Julia's Child",
            "short_desc": "Search, save, and collect recipes. Just like Grandma used to do, but online.",
            "long_desc": "Version 1.0 of this online recipe box allows users to search the Edamame API to find new and exciting recipes to add to their digital recipe collection, or add their own. Version 2.0 will include a weekly meal planner, and the ability to create a grocery list from each week's meal plan",
            "year": 2019,
            "img": ["recipe1.jpg", "recipe2.jpg", "recipe3.jpg"],
            "github": "https://github.com/rbompiani/Project2",
            "demo": "https://frozen-plateau-58578.herokuapp.com/index",
            "wireframe": "https://xd.adobe.com/view/9b0cb70d-5cb6-45c9-4e9d-541deefa97d6-ed3d/",
            "major_skill": "node",
            "skills": ["javascript", "mysql", "node"]
        },
        {
            "id": 2,
            "title": "Interactive Campus",
            "short_desc": "An interactive map-based interface that would allow planners, registrars, and department members alike to view their campus data more succinctly",
            "long_desc": "Oregon State University was struggling to provide facilities for an explosive increase in student enrollment. By aggregating existing data into interactive and visual formats, we were able to provide recommendations for efficient expansion of the campus.",
            "year": 2011,
            "img": ["campus1.jpg", "campus2.jpg", "campus3.jpg"],
            "github": "https://github.com/rbompiani/campusMapping",
            "demo": "http://rbompiani.com/OSU/",
            "major_skill": "javascript",
            "skills": ["javascript", "mysql"]
        },
        {
            "id": 3,
            "title": "Cupboard Companion",
            "short_desc": "Monitor and manage your inventory with sensors that log data in real time",
            "long_desc": "With the help of Arduino and the Johnny5 Library, Users can track inventory by weight in real time. Each inventory item has an email reminder to reorder when the stock reaches a designated threshold.  Reorder inventory by clicking on the gauge's associated reorder link",
            "year": 2019,
            "img": ["cupboard1.jpg", "cupboard2.jpg", "cupboard3.jpg"],
            "github": "https://github.com/rbompiani/CupboardCompanion",
            "wireframe": "https://xd.adobe.com/view/f5930a4a-704d-4486-6a21-42cda84acba3-83a2/",
            "major_skill": "react",
            "skills": ["react", "node", "mysql"]
        },
        {
            "id": 4,
            "title": "Dynamic 3D",
            "short_desc": "Shop for car accessories dynamically in 3d, from the comfort of your own home",
            "long_desc": "Levarage webGL and javascript to build dynamic 3d models. Accessories turn on and off in real time, and the camera automatically adjusts to view those accessories. A running sidebar of options and pricing keeps you up to date as you add and remove parts ",
            "year": 2014,
            "img": ["auto1.jpg", "auto2.jpg"],
            "demo": "http://rbompiani.com/projects/chrysler/index.html",
            "major_skill": "javascript",
            "skills": ["javascript", "css"]
        },
        {
            "id": 5,
            "title": "Think You Know Flags?",
            "short_desc": "A simple, yet stylish, guessing game. How well do you think you know world flags?",
            "long_desc": "To keep users engaged in this simple guessing game, CSS animations flip cards to reveal correct guesses, provide excitement and engaging feedback.",
            "year": 2019,
            "img": ["Flags1.jpg"],
            "github": "https://github.com/rbompiani/WordGuessGame",
            "demo": "http://rbompiani.com/projects/Flags/",
            "major_skill": "css",
            "skills": ["css", "javascript"]
        }
    ]

}
export default ProjectData;